import React from 'react';
/**
 * Scrollable event list for the MoreEventsPopover.
 * CSS max-height + overflow-y provides a smooth, performant experience for the
 * typical per-day event counts seen in the popover (usually <100 items).
 */
export function DayCellEventList({ events, renderEvent }) {
    return (React.createElement("div", { className: "qmb-month-grid__popover-list" }, events.map((event) => (React.createElement("div", { key: event.id, className: "qmb-month-grid__popover-event" }, renderEvent(event))))));
}
